import { css } from '@emotion/react';
import { DesignComponent, LargeDivider } from '@minted/fancyclothes';
import { styleUtils } from '@minted/minted-components';
import React, { memo } from 'react';
import {
  Page, Section, WebsiteEvent,
} from '../../resources/modelTypes';
import { selectCollection, SelectedCollection } from '../../resources/selectors';
import { connect } from 'react-redux';
import { RootState } from '../../resources/reduxTypes';
import { flex1 } from '../../content/styles';
import { textAlignmentMap } from '../../content/configuration';
import { DisplayWebsiteContent } from '../website-display/DisplayWebsiteContent';
import { PageSlugs } from '../types';
import DisplayTitle from '../../pages/website/DisplayTitle';
import { PageDisplayModes } from '../../website/components/EditDesign/constants';

const wrapperStyles = css`
  max-width: ${styleUtils.rem(975)};
  margin: 0 auto;
  padding-bottom: ${styleUtils.rem(80)};
`;

export type PageDesignComponentProps = {
  displayMode: string,
  page: Page,
}

type PageDesignComponentPropsWithRedux = {
  sectionCollection: SelectedCollection<Section>,
  eventCollection: SelectedCollection<WebsiteEvent> | null,
} & PageDesignComponentProps;

class PageDesignComponent extends DesignComponent {
  props?: PageDesignComponentPropsWithRedux;
  render() {
    if (!this.props) {
      return null;
    }
    const {
      displayMode,
      eventCollection,
      page,
      sectionCollection,
    } = this.props;

    return (
      <>
        {
          page.slug !== PageSlugs.Home && displayMode === PageDisplayModes.multiPage && (
            <>
              <LargeDivider />
              <DisplayTitle
                hideDivider={!page.configuration.showPageDividers}
                title={page.givenName}
              />
            </>
          )
        }
        <div
          css={wrapperStyles}
          id={`${page.slug}`}
        >
          <div
            css={
              [
                flex1,
                textAlignmentMap.get(page.configuration.textAlignment),
              ]
            }
          >
            <div>
              <DisplayWebsiteContent
                configuration={page.configuration}
                eventCollection={eventCollection}
                sectionCollection={sectionCollection}
                slug={page.slug}
              />
            </div>
          </div>
        </div>
        <LargeDivider />
      </>
    );
  }
}

const mapStateToProps = (state: RootState, props: PageDesignComponentProps) => ({
  eventCollection: props.page.slug === PageSlugs.Events ? selectCollection(state.resources.events) : null,
  sectionCollection: selectCollection(state.resources.sections, {
    page: props.page.id,
  }),
});

// @ts-expect-error Force types for redux/react connection
const ConnectedPageDesignComponent = connect(mapStateToProps)(PageDesignComponent) as React.FC<PageDesignComponentProps>;

const MemoizedPageDesignComponent = memo(ConnectedPageDesignComponent);

export { MemoizedPageDesignComponent as PageDesignComponent };
